import { render, staticRenderFns } from "./DetailPageTemplate.vue?vue&type=template&id=2c170fe2&scoped=true&"
import script from "./DetailPageTemplate.vue?vue&type=script&lang=js&"
export * from "./DetailPageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./DetailPageTemplate.vue?vue&type=style&index=0&id=2c170fe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c170fe2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
